import { Drawer, ListItem, List, ListItemText, Divider } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { hasPowFeature, POW_FEATURES } from "../services/powFeatures.service";
import colors from "../constants/colors";
import { useHistory } from "react-router-dom";
import { includes } from "../utils";

const useStyles = makeStyles(() => ({
	drawer: {
		marginTop: "58px",
		width: "150px",
		backgroundColor: colors.gray100,
	},
}));

/**
 * This Component is the side navigation bar for the subscription sub pages.
 * It utilizes react router navigation to switch the pages.
 * @param subscriptionPath
 */
export const SubscriptionNavigationBar = (subscriptionPath: any) => {
	const classes = useStyles();
	const history = useHistory();
	return (
		<Drawer
			className={classes.drawer}
			variant="permanent"
			anchor="left"
			classes={{
				paper: classes.drawer,
			}}
		>
			<List>
				<ListItem
					button
					key={"Details"}
					selected={window.location.pathname === subscriptionPath.url}
					onClick={() => {
						history.push(`${subscriptionPath.url}`);
					}}
				>
					<ListItemText>Details</ListItemText>
				</ListItem>
				{hasPowFeature(POW_FEATURES.paSubscriptions_CallLogs) && (
					<span>
						<Divider />
						<ListItem
							button
							key={"CallLogs"}
							selected={includes(window.location.pathname, "SubscriptionCallList")}
							onClick={() => {
								history.push(`${subscriptionPath.url}/SubscriptionCallList`);
							}}
						>
							<ListItemText>Call Logs</ListItemText>
						</ListItem>
					</span>
				)}
				{hasPowFeature(POW_FEATURES.paSubscriptions_AllLogs) && (
					<span>
						<Divider />
						<ListItem
							button
							key={"AllLogs"}
							selected={includes(window.location.pathname, "AllTwilioLogs")}
							onClick={() => {
								history.push(`${subscriptionPath.url}/AllTwilioLogs`);
							}}
						>
							<ListItemText>All Logs</ListItemText>
						</ListItem>
					</span>
				)}
				{hasPowFeature(POW_FEATURES.paSubscriptions_ChannelLogs) && (
					<span>
						<Divider />
						<ListItem
							button
							key={"ChannelLogs"}
							selected={includes(window.location.pathname, "TwilioChannelList")}
							onClick={() => {
								history.push(`${subscriptionPath.url}/TwilioChannelList`);
							}}
						>
							<ListItemText>Channel Logs</ListItemText>
						</ListItem>
					</span>
				)}
				{hasPowFeature(POW_FEATURES.paSubscriptions_WorkerLogs) && (
					<span>
						<Divider />
						<ListItem
							button
							key={"WorkerLogs"}
							selected={includes(window.location.pathname, "TwilioWorkerLogs")}
							onClick={() => {
								history.push(`${subscriptionPath.url}/TwilioWorkerLogs`);
							}}
						>
							<ListItemText>Worker Logs</ListItemText>
						</ListItem>
					</span>
				)}
				{hasPowFeature(POW_FEATURES.paSubscriptions_Licenses) && (
					<span>
						<Divider />
						<ListItem
							button
							key={"Licenses"}
							selected={includes(window.location.pathname, "Licenses")}
							onClick={() => {
								history.push(`${subscriptionPath.url}/Licenses`);
							}}
						>
							<ListItemText>Licenses</ListItemText>
						</ListItem>
					</span>
				)}
				{hasPowFeature(POW_FEATURES.paSubscriptions_NamedResources) && (
					<span>
						<Divider />
						<ListItem
							button
							key={"NamedResources"}
							selected={includes(window.location.pathname, "NamedResources")}
							onClick={() => {
								history.push(`${subscriptionPath.url}/NamedResources`);
							}}
						>
							<ListItemText>Named Resources</ListItemText>
						</ListItem>
					</span>
				)}
			</List>
		</Drawer>
	);
};
